module.exports = __webpack_public_path__ + "static/media/Dropdown-arrow.2318fcdc.svg";